<template>
  <div :class="{ 'collaped_sidebar': !segment_view }" style="
        position: sticky;
        z-index: 2;
  
        height: 100%;
        display: flex;
        left: 0px;
        top:0px;
  min-width: 200px;

     
            background-color:#fff;
            box-shadow: rgb(0 0 0 / 43%) 0px -2px 6px;

      " :style="{ 'height': container_height + 40 + 'px' }">
      


<div style="height: 40px;
    z-index: 1;
    top: 0px;
    position: sticky;
    background-color: #ffffff; display:flex; align-items:center; padding:6px;">

  <!-- close (hide) icon shown when panel is open -->
  <div v-if="segment_view" @click="$emit('update:segment_view', false)" style="cursor:pointer; display:flex; align-items:center;">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Chiudi pannello">
      <path d="M15 6L9 12L15 18" stroke="#444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>

  <!-- open (show) icon shown when panel is closed -->
  <div v-if="!segment_view" @click="$emit('update:segment_view', true)" style="cursor:pointer; display:flex; align-items:center;">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Apri pannello">
      <path d="M9 6L15 12L9 18" stroke="#444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>

</div>

      <div v-for="(segment) in render_segments" :key="segment.key.team_id + segment.key.team_type" style="position: absolute; display: flex;flex-direction: column;
           border-bottom: 1px solid #eeeeee; width: 100%;"
        :style="{ 'background-color': '#fff', 'top': segment.top + 40 + 'px', 'height': segment.height + 'px' }">
        <div :title="segment.key.name " style="padding:10px;font-size: 16px; align-items: center; display: flex; 
            gap:5px; white-space: nowrap;">
          <img v-if="segment.key.image != null && segment.key.image != ''" style="
              width: 30px;
              height: 30px;
              border-radius: 50%;
              border: 1.5px solid white;
              min-width: 30px;
              min-height: 30px;
              background-size: cover;
            " :style="{'background-image': 'url(' + segment.key.image + ')'}" />
            <div v-else style="
              width: 30px;
              height: 30px;
              border-radius: 50%;
              border: 1.5px solid white;
              min-width: 30px;
              min-height: 30px;
              background-color: #bdbdbd;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              color: white;
              font-size: 16px;
              background-size: cover;">
              {{ segment.key.name.charAt(0).toUpperCase() }}
            </div>
          <div style=" text-overflow: ellipsis; overflow: hidden;">
            {{ segment.key.name }}
          </div>

        </div>
      </div>
    </div>



</template>


<script>
import "dayjs/locale/it";
export default {
  name: "gant-grid-sidebar",
  props: ["segment_view", "render_segments", "container_height"],
};
</script>

<style scoped>
.events-container {
  height: 200px;
  height: 100%;
  position: relative;
}

.event {
  z-index: 1;
  display: inline-block;
  background-color: #673ab7;
  color: #fff;
  position: absolute;
  border-radius: 3px;
  padding: 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 34px;
  cursor: pointer;
  border: 0.5px solid #fff;
  transition: all 0.25s;
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
}

.event .event_drag {
  min-width: 10px;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
  font-size: 12px;
}

.event:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.collaped_sidebar {
  min-width: 50px!important;
}

.hide_segment {
  --translate-x: 0px !important;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}



.by-scroll-container::-webkit-scrollbar-track {
  background-color: #fff;
}

.by-scroll-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}

.by-scroll-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #999;
}
</style>